<template>
    <v-card
      class="mx-auto"
      max-width="344"
      title="Enregistrement utilisateur"
    >
      <v-container>
        <v-text-field
          v-model="data.prenom"
          color="primary"
          label="Prénom"
          variant="outlined"
          :rules="[rules.required]"
        ></v-text-field>
  
        <v-text-field
          v-model="data.nom"
          color="primary"
          label="Nom"
          variant="outlined"
          :rules="[rules.required]"
        ></v-text-field>
  
        <v-text-field
        :rules="[rules.required]"
          v-model="data.email"
          color="primary"
          label="Email"
          variant="outlined"
        ></v-text-field>
        
        <v-text-field    
          v-model="data.tel"
          color="primary"
          label="Téléphone"
          variant="outlined"
        ></v-text-field>

        <v-text-field
      
          v-model="data.password"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show1 ? 'text' : 'password'"
          color="primary"
          label="Mot de passe"
          placeholder="Saisir un mot de passe"
          variant="outlined"
          @click:append="show1 = !show1"
        ></v-text-field>
  
        <v-combobox
        variant="outlined"
            v-model="data.role"
            :items="items"
            density="comfortable"
            label="Role"
          ></v-combobox>
        
          <v-checkbox
      v-model="data.active"
      label="Active"
    ></v-checkbox>

      </v-container>
  
      <v-divider></v-divider>
  
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn variant="elevated" @click="valider()" :disabled="!isValid()"  color="blue-darken-4"
         class="text-none ms-4 text-white">
          Valider  
        </v-btn>
        <v-btn variant="elevated" route to="/user/listuser"  color="red-darken-4"
         class="text-none ms-4 text-white" >
          Annuler  
        </v-btn>

      </v-card-actions>
    </v-card>
  </template>
  <script>
import http from '../../http.js'

  export default {
    
    data: () => ({
      rules: {
        required: value => !!value || 'Le champ est obligatoire',
      },
      show1:false,
      prenom: null,
      nom: null,
      email: null,
      password: null,
      items:['admin','utilisateur'],
      data:{}
    
    }),
    mounted(){
      this.modifier()

    },
    methods:{
      isValid(){
        return this.data.prenom!=undefined
        && this.data.nom!=undefined
        &&this.data.email!=undefined
      },
      async valider(){
        

         // if(this.$route.params.id ==undefined){
          
           await http.post("/api/utilisateur",this.data).then( this.creation=false);
            this.$router.push('/user/listuser')
          } ,
          modifier(){
           
            if(this.$route.params.id !=undefined){
              http.get("/api/utilisateur/"+this.$route.params.id).then( res=>{this.data=res.data});

            }
          } 
    }
  }
</script>